import { render, staticRenderFns } from "./EaseInBorderIcon.vue?vue&type=template&id=44d5a11d&"
import script from "./EaseInBorderIcon.vue?vue&type=script&lang=js&"
export * from "./EaseInBorderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports